<template>
  <main>
    <!-- Hero section -->
    <div
      class="relative bg-cover bg-center"
      :style="{
        backgroundImage: `url(${require('../assets/images/bum-image.jpg')})`,
      }"
    >
      <div class="absolute inset-0 bg-black bg-opacity-50"></div>
      <div
        class="relative md:px-12 sm:px-12 px-2 max-w-screen-2xl mx-auto z-10 h-[60vh] flex items-center justify-start text-white"
      >
        <!-- BUM effect Section -->
        <h1
          class="text-4xl md:text-6xl font-bold animate__animated animate__backInLeft"
        >
          Welcome to Barka .U. Mshelia Impact
        </h1>
      </div>

      <!-- Sleek Arch SVG Curve -->
      <svg
        class="absolute bottom-0 left-0 w-full"
        viewBox="0 0 1440 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="#ffffff"
          d="M0,0 C480,100 960,100 1440,0 L1440,100 L0,100 Z"
        />
      </svg>
    </div>

    <!-- Section: Introduction -->
    <section class="bg-gradient-to-br from-blue-50 to-white py-10">
      <div class="max-w-4xl mx-auto px-4 text-center animate-fade-in">
        <p class="text-2xl text-gray-600 leading-relaxed">
          A legacy of excellence in real estate, entrepreneurship, and global
          leadership — this is the story of
          <span class="font-semibold text-main">Barka Umaru Mshelia</span>.
        </p>

        <div class="grid place-items-center mt-10">
          <img
            src="../assets/images/tribal-image.jpeg"
            alt="Harvard Graduation"
            class="h-96 w-full max-w-2xl object-cover rounded-3xl shadow-xl transform hover:scale-105 transition duration-500"
          />
        </div>
      </div>
    </section>

    <!-- Section: Harvard Education -->
    <section class="bg-white py-24">
      <div
        class="max-w-screen-xl mx-auto px-4 grid md:grid-cols-2 gap-12 items-center"
      >
        <img
          src="../assets/images/harvard.jpeg"
          alt="Harvard Graduation"
          class="w-full rounded-3xl shadow-xl transform hover:scale-105 transition duration-500"
        />
        <div class="animate-slide-in-right">
          <h2 class="text-4xl font-bold text-gray-800 mb-4">
            Harvard Business School Alumnus
          </h2>
          <p class="text-gray-600 text-lg leading-relaxed mt-10">
            Barka Umaru Mshelia sharpened his global business perspective at
            Harvard, where he engaged with distinguished scholars and peers from
            around the world.
          </p>
          <p class="text-gray-600 text-lg leading-relaxed mt-2">
            His time at Harvard equipped him with transformative leadership
            skills and a strong foundation in international business strategy.
          </p>
          <p class="text-gray-600 text-lg leading-relaxed mt-2">
            Becoming part of Harvard’s elite alumni network, Barka expanded his
            influence and deepened his understanding of impactful, global
            leadership.
          </p>
        </div>
      </div>
    </section>

    <!-- Pitch your dream for Mshel Foundation -->
    <buildingCommunities />

    <!-- Section: Global Business Trips -->
    <section class="bg-gray-50 py-24">
      <div class="max-w-screen-xl mx-auto px-4">
        <h2 class="text-4xl font-bold text-center text-gray-800 mb-12">
          Global Business Expeditions
        </h2>
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          <div
            class="overflow-hidden rounded-2xl shadow-lg transform hover:scale-105 transition duration-500"
          >
            <img
              src="../assets/images/dubai-image.jpeg"
              alt="Dubai Trip"
              class="w-full h-64 object-cover"
            />
          </div>
          <div
            class="overflow-hidden rounded-2xl shadow-lg transform hover:scale-105 transition duration-500"
          >
            <img
              src="../assets/images/barka-mshelia.jpeg"
              alt="Tokyo Leadership Summit"
              class="w-full h-64 object-cover"
            />
          </div>
          <div
            class="overflow-hidden rounded-2xl shadow-lg transform hover:scale-105 transition duration-500"
          >
            <img
              src="../assets/images/conference-image.jpeg"
              alt="New York Business Forum"
              class="w-full h-64 object-cover"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- Section: Final Quote -->
    <section class="bg-white py-24">
      <div class="max-w-2xl mx-auto text-center px-4">
        <blockquote
          class="text-2xl text-main italic font-medium leading-relaxed"
        >
          “Great leaders don't just build businesses - they build people,
          communities, and nations.”
        </blockquote>
        <p class="mt-4 text-gray-600 text-lg">- B.U Mshelia</p>
      </div>
    </section>
  </main>
</template>

<script>
import buildingCommunities from "../components/buildingCommunties.vue";
export default {
  components: {
    buildingCommunities,
  },
};
</script>

<style scoped>
svg path {
  fill: #fff !important;
  stroke: none !important;
  box-shadow: none !important;
}

svg {
  overflow: hidden !important;
}

.absolute.bottom-0 {
  line-height: 0 !important;
  padding-bottom: 0 !important;
  margin-bottom: -2px;
}

.overflow-hidden {
  overflow: hidden !important;
}

.text-2xl {
  font-size: 18px !important;
}

.text-lg {
  font-size: 14px !important;
}
</style>
